import React, { useState } from 'react';
import {
  Stack,
  TextField,
  Button,
  List,
  Pagination,
  Typography,
} from '@mui/material';

// COMPONENTS
import TemplateListItem from './TemplateListItem';

// MESSAGES
import TemplateFormattedMessages from '../../messages/websms/TemplateFormattedMessages';

// CONFIG
import config from '../../Config';

const GlobalList = ({ list, handleSelect, callBack, errorHandler }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const pageLength = config.defaultPL;

  /*
    Handles the change event when clicking a pagination number
  */
  const changeEvent = (event, value) => {
    setPageNumber(value);
  };

  /*
    Handles changes in the form
  */
  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    setPageNumber(1);
  };

  /*
    Handles global template search
  */
  const handleSearchFilter = () => {
    if (searchValue) {
      return list.filter((contact) => {
        return `${contact.template_name}`
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
    }
    return list;
  };

  const filteredList = handleSearchFilter();
  const listLen = filteredList ? filteredList.length : 0;

  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <TextField
        id="contactSearch"
        label={TemplateFormattedMessages.searchGlobalTemplates}
        variant="outlined"
        value={searchValue}
        onChange={handleSearchChange}
        fullWidth
        size="small"
      />

      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h3">
          {TemplateFormattedMessages.globalTemplateTitle}: {listLen}
        </Typography>

        <Button variant="contained" color="secondary" onClick={callBack}>
          {TemplateFormattedMessages.createNewButton}
        </Button>
      </Stack>

      <List
        sx={{
          border: '1px solid',
          borderColor: 'secondary.light',
          borderRadius: 2,
        }}
        disablePadding
      >
        <TemplateListItem
          filteredList={filteredList}
          pageLength={pageLength}
          pageNumber={pageNumber}
          handleSelect={handleSelect}
        />
      </List>

      <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Pagination
          count={Math.ceil(listLen / pageLength)}
          page={pageNumber}
          onChange={changeEvent}
          color="secondary"
        />
      </Stack>
    </Stack>
  );
};

export default GlobalList;
